/**
 * Vuetify 2 tema renkleri (hex).
 * src/styles/colors.scss içindeki $light-* / $dark-* ve durum renkleriyle hizalı tutun.
 */

export const vuetifyLightTheme = {
  primary: '#EB575D',
  secondary: '#5CC9BF',
  accent: '#4789F7',
  error: '#E60004',
  info: '#4789F7',
  success: '#00AC4F',
  warning: '#EFB424',
  background: '#F7F8FB',
  surface: '#FFFFFF',
  'on-surface': '#171D22',
  'on-background': '#171D22',
  'surface-1': '#F7F8FB',
  'surface-3': '#E9EDF1',
  'icon-muted': '#93A0AF',
  'foreground-3': '#5C6A75',
};

export const vuetifyDarkTheme = {
  primary: '#EB575D',
  secondary: '#5CC9BF',
  accent: '#4789F7',
  error: '#E60004',
  info: '#4789F7',
  success: '#00AC4F',
  warning: '#EFB424',
  background: '#171D22',
  surface: '#262E35',
  'on-surface': '#FFFFFF',
  'on-background': '#FFFFFF',
  'surface-1': '#171D22',
  'surface-3': '#343E47',
  'icon-muted': '#93A0AF',
  'foreground-3': '#B7C0CA',
};
